<template>
  <!-- 购销计划一览表 -->
  <table class="monthly-report">
    <thead>
      <th
        colspan="6"
        style="height: 40px;border-bottom: 1px solid #ebeef5;"
      >
        <label class="report-line" />
        <span class="report-title">购销计划一览表</span>
      </th>
    </thead>
    <tr>
      <td style="width:100px">
        <span
          class="monthly-report-label"
          style="margin-left: 10px;"
        >客户：</span>
      </td>
      <td style="width:200px">
        <span class="monthly-report-text">{{ tableData.userAccount }}</span>
      </td>
      <td style="width:120px">
        <span class="monthly-report-label">客户名称：</span>
      </td>
      <td style="width:200px">
        <span class="monthly-report-text">{{ tableData.userName }}</span>
      </td>
      <td style="width:100px">
        <span class="monthly-report-label">组织：</span>
      </td>
      <td style="width:200px">
        <span class="monthly-report-text">{{ tableData.marketName }}</span>
      </td>
    </tr>
  </table>
</template>
<script>
export default {
  name: 'PurchaseSaleList',
  props: {
    tableData: {
      type: Object,
      default: () => {}
    }
  }
}

</script>
<style lang="scss" scoped>
  // 按钮对齐搜索框
  ::v-deep .table-page-search-submitButtons {
    margin-left: 100px
  }

  .red {
    color: red
  }

  .monthly-report {
    border: 1px solid #ebeef5;
    width: 100%;
    font-size: 12px;
    background-color: white;
    margin: 15px 0 15px 0;
  }

  .monthly-report .report-line {
    margin-left: 10px
  }

  .monthly-report td {
    height: 40px;
  }

  .monthly-report-label {
    color: #333333;
    font-weight: bold;
    padding: 0 10px;
  }

</style>
